export class ActualityModel {
  Id: any;
  Title: any;
  Content: any;
  CreatedAt: any;
  Category: any;
  Media: any
  IsToday: boolean = false;

  public mapToModel(data: any): ActualityModel {
    const newsModel = new ActualityModel();
    newsModel.Id = data.id;
    newsModel.Title = data.title;
    newsModel.Content = data.content;
    newsModel.Category = data.category;
    newsModel.Media = data.media;
    newsModel.CreatedAt = data.createdAt;

    return newsModel;
  }
}
